const number = (value) => Math.max(0, Number(value) || 0);

export const isCollegeWorkspace = (workspace = {}) => {
  if (workspace.is_school || workspace.is_gym) return false;
  const settings = workspace.settings || {};
  return [settings.category, settings.segment, settings.dashboardStyle].some((value) =>
    ["college", "university"].includes(String(value || "").trim().toLowerCase()));
};

export const buildCollegeDashboard = (dashboard = {}) => {
  const workspace = dashboard.workspace || {};
  const locked = workspace.steps_locked === true || workspace.access_active === false;
  const rank = (rows) => [...(rows || [])].sort((a, b) => locked
    ? String(a.name || "").localeCompare(String(b.name || ""))
    : number(b.steps) - number(a.steps) || String(a.name || "").localeCompare(String(b.name || "")));
  const students = rank(dashboard.members);
  const groups = rank((dashboard.teams || []).filter((team) => team.kind !== "challenge"));
  const challenges = rank((dashboard.teams || []).filter((team) => team.kind === "challenge"));
  const summary = workspace.settings?.demo_seed ? {} : workspace.activity_summary || {};
  const studentCount = summary.member_count == null ? students.length : number(summary.member_count);
  const totalSteps = locked ? null : summary.total_steps == null
    ? students.reduce((sum, student) => sum + number(student.steps), 0) : number(summary.total_steps);
  const campusImage = [workspace.settings?.coverImageUrl, ...groups.map((group) => group.image),
    ...challenges.map((challenge) => challenge.image)]
    .find((url) => url && url !== workspace.logo_url) || "";
  return {
    workspace, locked, students, groups, challenges, studentCount, totalSteps,
    averageSteps: locked ? null : studentCount ? Math.round(totalSteps / studentCount) : 0,
    leader: locked ? null : students.find((student) => number(student.steps) > 0) || null,
    campusImage,
  };
};
